const getOrderLineSupplyType = ({ orderLine, value, index }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (index !== undefined) {
    const indexOrderLine = orderLine ? orderLine[index] : null;
    if (indexOrderLine) {
      if (indexOrderLine.Product['Last Arrival Stock Line']) {
        if (indexOrderLine.Product['Last Arrival Stock Line']['Quantity In Case']
          && indexOrderLine.Product['Calories Per Unit']) {
          return 'CU';
        } else if (indexOrderLine.Product['Last Arrival Stock Line']['Quantity In Case']
          && !indexOrderLine.Product['Calories Per Unit']) {
          return 'BX';
        } else {
          return null;
        }
      } else {
        return null;
      }
    }
    return null;
  }
  return orderLine
    ? orderLine.map(item => {
      if (item.Product['Last Arrival Stock Line']) {
        if (item.Product['Last Arrival Stock Line']['Quantity In Case']
          && item.Product['Calories Per Unit']) {
          return 'CU';
        } else if (item.Product['Last Arrival Stock Line']['Quantity In Case']
          && !item.Product['Calories Per Unit']) {
          return 'BX';
        } else {
          return null;
        }
      } else {
        return null;
      }
    }).filter(item => item).join(', ')
    : null;
};

export default getOrderLineSupplyType;



// WEBPACK FOOTER //
// ./src/utils/print/getOrderLineSupplyType.js